import { Outlet, useNavigate } from "react-router";
import { Button } from "@illustraclass/ui";
import { ArrowLeft, Users } from "lucide-react";

export function AdminLayout() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card px-6 py-4">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                void navigate("/dashboard");
              }}
              aria-label="Retour au tableau de bord"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-xl font-bold text-foreground">
                Administration
              </h1>
              <p className="text-sm text-muted-foreground">
                Gestion de la plateforme IllustraClass
              </p>
            </div>
          </div>
          <nav className="flex items-center gap-2">
            <Button
              variant="outline"
              onClick={() => {
                void navigate("/admin/teachers");
              }}
            >
              <Users className="mr-2 h-4 w-4" />
              Professeurs
            </Button>
          </nav>
        </div>
      </header>

      <div className="mx-auto max-w-6xl p-6">
        <Outlet />
      </div>
    </div>
  );
}
